import React from 'react';

const CTABanner: React.FC = () => {
  return (
    <section className="py-16 bg-gradient-growlyy">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="mb-8 md:mb-0 text-center md:text-left">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
              Prêt à booster votre prospection commerciale ?
            </h2>
            <p className="text-xl text-gray-100">
              Commencez dès aujourd'hui et obtenez vos premiers rendez-vous qualifiés
            </p>
          </div>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <a href="https://zcal.co/adriengeen/15min" target="_blank" rel="noopener noreferrer" className="btn-primary btn-large btn-pulse">
              Commencez maintenant
            </a>
            <a href="https://zcal.co/adriengeen/15min" target="_blank" rel="noopener noreferrer" className="btn-secondary text-white hover:bg-white btn-large">
              Réserver une démo
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner; 